export const API_ENDPOINT_V1 = process.env.REACT_APP_API_V1;
export const API_TOKEN =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOjEwMywiaXNzIjoiaHR0cHM6Ly9icm9rZXItYXBpLmNvZGlhbnRkZXYuY29tL2FwaS9sb2dpbiIsImlhdCI6MTcyNTUxMzkyMCwiZXhwIjoxNzQ0OTUzOTIwLCJuYmYiOjE3MjU1MTM5MjAsImp0aSI6ImxsVlNYWWNsTVNIWUhEVmcifQ.5wIlKN6N2G-e4TUAkBis9pTyBS8zKyhNvKzp4WtQWNY";
